<template>
	<div class="grid">
		<div class="col-12 lg:col-6 xl:col-3">
			<div v-on:click="goToApplication()">
			<div class="card mb-0 zoom">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Total Application</span>
						<div class="text-900 font-medium text-xl">{{dashcount.totalApplication}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:3.5rem;height:3.5rem">
						<i class="pi pi-fw pi-user text-blue-500 text-xl"></i>
					</div>
				</div>
				<!-- <span class="text-green-500 font-medium">24 new </span>
				<span class="text-500">since last visit</span> -->
			</div>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div v-on:click="goToPendingApplication()">
			<div class="card mb-0 zoom">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Pending Application</span>
						<div class="text-900 font-medium text-xl">{{dashcount.pendingApplication}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width:3.5rem;height:3.5rem">
						<i class="pi pi-fw pi-user text-orange-500 text-xl"></i>
					</div>
				</div>
				<!-- <span class="text-green-500 font-medium">%52+ </span>
				<span class="text-500">since last week</span> -->
			</div>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div @click="go('/ApplicationList',9)">
			<div class="card mb-0 zoom">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Rejected Application</span>
						<div class="text-900 font-medium text-xl">{{dashcount.rejectedApplication}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-cyan-100 border-round" style="width:3.5rem;height:3.5rem">
						<i class="pi pi-inbox text-cyan-500 text-xl"></i>
					</div>
				</div>
				<!-- <span class="text-green-500 font-medium">520  </span>
				<span class="text-500">newly registered</span> -->
			</div>
			</div>
		</div>
		<div class="col-12 lg:col-6 xl:col-3">
			<div @click="go('/ApplicationList',10)">
			<div class="card mb-0 zoom">
				<div class="flex justify-content-between mb-3">
					<div>
						<span class="block text-500 font-medium mb-3">Approved Application</span>
						<div class="text-900 font-medium text-xl">{{dashcount.approvedApplication}}</div>
					</div>
					<div class="flex align-items-center justify-content-center bg-purple-100 border-round" style="width:3.5rem;height:3.5rem">
						<i class="pi pi-comment text-purple-500 text-xl"></i>
					</div>
				</div>
				<!-- <span class="text-green-500 font-medium">85 </span>
				<span class="text-500">responded</span> -->
			</div>
			</div>
		</div>
</div>
</template>

<script>
import EventBus from '@/AppEventBus';
import ProductService from '../service/ProductService';
import apis from "@/apis";

export default {
	data() {
		return {
			get_date:"",
			get_date_2:"",
			products: null,
			todayslectures:[],
			dashcount:{
				"totalApplication":0,
				"approvedApplication":0,
				"rejectedApplication":0,
				"pendingApplication":0
			},
			// lineData: {
			// 	labels: ['0','0 to 20', '20 to 40', '40 to 60', '60 to 80', '80 to 100'],
			// 	datasets: [
			// 		{
			// 			label: 'Network',
			// 			data: [],
			// 			backgroundColor: '#00bb7e',
						
			// 		},
			// 		// {
			// 		// 	label: 'Sales',
			// 		// 	data: [],
			// 		// 	fill: false,
			// 		// 	backgroundColor: '#00bb7e',
			// 		// 	borderColor: '#00bb7e',
			// 		// 	tension: 0.4
			// 		// }
			// 	]
			// },
			// barData: {
			// 	labels: ['0 to 1 GB', '1 to 4 GB', '4 to 6 GB', '6 to 10 GB', '10 GB Above'],
			// 	datasets: [
			// 		{
			// 			label: 'Data Usages',
			// 			backgroundColor: '#2f4860',
			// 			data: []
			// 		}
			// 	]
			// },
			// 	barData1: {
			// 	labels: [],
			// 	datasets: [
			// 		{
			// 			label: 'No Of Lectures by Teacher',
			// 			backgroundColor: '#2f4860',
			// 			data: []
			// 		}
			// 	]
			// },
			barOptions:null,
			barOptions1:null,
			items: [
                {label: 'Add New', icon: 'pi pi-fw pi-plus'},
                {label: 'Remove', icon: 'pi pi-fw pi-minus'}
            ],
			lineOptions: null,
		}
	},
	productService: null,
	themeChangeListener: null,
	mounted() {
		// this.productService.getProductsSmall().then(data => this.products = data);

		// this.themeChangeListener = (event) => {
        //     if (event.dark)
        //         this.applyDarkTheme();
        //     else
        //         this.applyLightTheme();
        // };
        // EventBus.on('change-theme', this.themeChangeListener);

		// if (this.isDarkTheme()) {
        //     this.applyDarkTheme();
        // }
        // else {
        //     this.applyLightTheme();
        // }
		this.dashboardcount();
		//this.get_date=new Date();
		//this.datausagereport();
		//this.get_date_2=new Date();
		//this.networkconnectivityreport();
		//this.todayslecturereport();
		//this.teacherlecturereportadmin();
	},
	beforeUnmount() {
        EventBus.off('change-theme', this.themeChangeListener );
    },
	created() {
		this.productService = new ProductService();

	},
	watch:{
		// get_date()
		// {
		// 	this.datausagereport();
		// },
		// get_date_2()
		// {
		// 	this.networkconnectivityreport();
		// }
	},
	methods: {
        goToApplication()
		{	//alert(987)
			this.$router.push('/ApplicationList');
		},
		goToPendingApplication()
		{
			this.$router.push('/PendingApplicationList');
		},
		
		go(path, statusType)
        {
          localStorage.setItem("status_id", statusType);
            this.$router.push(path);
		},
		// go_to_student()
		// {	//alert(987)
		// 	this.$router.push('/studentmaster');
		// },
		// go_to_teacher()
		// {
		// 	this.$router.push('/teachermaster');
		// },
		// go_to_subject()
		// {
		// 	this.$router.push('/subjectmaster/12');
		// },
		// go_to_user()
		// {
		// 	this.$router.push('/userqueriesmaster');
		// },
		// go_to_net_connect()
		// {
		// 	this.$router.push('/userqueriesmaster');
		// },
		// go_to_data_usage()
		// {
		// 	this.$router.push('/userqueriesmaster');
		// },
		// go_to_news()
		// {
		// 	this.$router.push('/NewsMaster/6');
		// },
		// go_to_Feedback()
		// {
		// 	this.$router.push('/userqueriesmaster');
		// },
		// go_to_Scemes()
		// {
		// 	this.$router.push('/SchemeMaster/10');
		// },
		// go_to_Notice()
		// {
		// 	this.$router.push('/NoticeMaster');
		// },
		dashboardcount(){
			var data = {
				RoleID :localStorage.getItem("user_role_id")
			}
				  var promise = apis.CmrfPmDashboardCount(data);
      promise
        .then(response => {
			// alert(1);
			// console.log(this.barData.datasets[0].data);
			this.dashcount=response.data;
			//console.log("dashcount",this.dashcount);
		});

		},
	// 	networkconnectivityreport(){
	// 		var D = new Date(this.get_date_2);
			
	// 	if(this.get_date_2)
	// 	{
	// 	var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
	// 	}
	// 	var data = {date:date};
	// 			  var promise = apis.networkconnectivityreport(data);
    //   promise
    //     .then(response => {
	// 		this.lineData.datasets[0].data=Object.values(response.data);
	// 	});

	// 	},
	// 	datausagereport()
	// 	{
	// 		var D = new Date(this.get_date);
			
	// 	if(this.get_date)
	// 	{
	// 	var date = D.toLocaleDateString("en-US", { year: "numeric" }) + "-" + D.toLocaleDateString("en-US", { month: "2-digit" }) + "-" + D.toLocaleDateString("en-US", { day: "2-digit" });
	// 	}
	// 	var data = {date:date};
	// 	var promise = apis.dashboarddatausagereport(data);
    //   promise
    //     .then(response => {
	// 		// alert(1);
	// 		// console.log(this.barData.datasets[0].data);
	// 		this.barData.datasets[0].data=Object.values(response.data);
	// 	});

	// 	},
	// 	teacherlecturereportadmin(){
	// 			  var promise = apis.teacherlecturereportadmin();
    //   promise
    //     .then(response => {
	// 		// alert(1);
	// 		// console.log(this.barData.datasets[0].data);
	// 		this.barData1.labels=response.data.teacher;
			
	// 		this.barData1.datasets[0].data=response.data.lectures;
	// 	});

	// 	},
	// 	todayslecturereport(){
	// 		var data={
	// 		"limit":5,
    // 		"page_no":1
	// 		}
			
	// 			  var promise = apis.todayslecturereport(data);
    //   promise
    //     .then(response => {
	// 		// alert(1);
	// 		// console.log(this.barData.datasets[0].data);
	// 		this.todayslectures=response.data;
	// 	});

	// 	},
	// 	formatCurrency(value) {
	// 		return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
	// 	},
		isDarkTheme() {
            return this.$appState.darkTheme === true;
        },
		applyLightTheme() {
			this.barOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#495057'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
					y: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
				}
			};
			this.barOptions1 = {
				indexAxis: 'y',
				plugins: {
					legend: {
						labels: {
							color: '#495057'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
					y: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
				}
			};
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#495057'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
					y: {
						ticks: {
							color: '#495057'
						},
						grid: {
							color:  '#ebedef',
						}
					},
				}
			};
		},
		applyDarkTheme() {
			this.lineOptions = {
				plugins: {
					legend: {
						labels: {
							color: '#ebedef'
						}
					}
				},
				scales: {
					x: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
					y: {
						ticks: {
							color: '#ebedef'
						},
						grid: {
							color:  'rgba(160, 167, 181, .3)',
						}
					},
				}
			};
		}
	}
}
</script>
<style scoped>
.zoom {
  transform-origin: 0% 0% 1% 1%;
  transition: transform 1s, filter 1s ease-in-out;
}
/* The Transformation */
.zoom:hover {
  transform: scale(1.1);
}
.color {
	box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px, rgba(0, 0, 0, 0.04) 0px 10px 10px -5px !important;
	background: linear-gradient(115deg, rgba(245, 155, 24, 1) 0%, rgba(242, 64, 19, 1) 63%);
}
</style>